<template>
<div>
  <h1 class="pb-5 has-text-weight-bold is-size-3">User Profile</h1>

  <div class="columns">
    <div class="column is-two-thirds">
      <table class="table is-fullwidth is-bordered">
        <tbody>
          <tr>
            <td><b-icon class="pr-3" icon="user"/> Name</td> <td> {{ userinfo.name }} {{userinfo.surname}}
              {{ userinfo.nickname ? `(${userinfo.nickname})` : '' }}
              <a v-if="!userinfo.nickname" @click="openSetNickname" class="ml-2"><b-icon icon="pencil-alt" size="is-small"/></a>
            </td>
          </tr>
          <tr>
            <td><b-icon class="pr-3" icon="envelope"/> Mail</td> <td> {{ userinfo.mail }} </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="column">
      <b-button icon-left="download" expanded v-for="file in files" :key="file.hash" tag="a" :href="`/cms/files/${file.hash}/${file.name}`">{{ file.name }}</b-button>
    </div>
  </div>

  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        <b-icon icon="paint-brush" /> Theme
      </p>
    </header>
     <div class="card-content">
       <div class="content">
         <form @submit.prevent="changeTheme">
           <b-field grouped labelPosition="on-border">
             <b-select expanded v-model="selected" placeholder="Choose a theme">
               <option
                 v-for="theme in themes"
                 :key="theme"
                 :value="theme"
                 >
                 {{ theme }}
               </option>
             </b-select>
             <b-button icon-left="save" native-type="submit">Save</b-button>
           </b-field>
           </form>

       </div>
     </div>
  </div>
  <slot name="userdata"></slot>
</div>
</template>

<script>
const SetNicknameForm = {
  template: `
    <form @submit.prevent="submit">
      <div class="modal-card" style="width: 30em">
        <header class="modal-card-head">
          <p class="modal-card-title"><b-icon icon="pencil-alt" /> Set Nickname</p>
          <button type="button" class="delete" @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
          <b-field label="Nickname">
            <b-input type="text" v-model="nickname" :disabled="loading" placeholder="Enter your nickname" maxlength="45" required/>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button label="Cancel" expanded @click="$emit('close')" />
          <b-button label="Save" native-type="submit" expanded type="is-primary" :loading="loading" />
        </footer>
      </div>
    </form>
  `,
  data() {
    return { nickname: null, loading: false };
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await this.$ctforge.api.post('/users/nickname', { nickname: this.nickname });
        this.notify('Nickname set', 'is-success');
        this.$emit('close');
      } catch (e) {
        this.notify(e.message, 'is-danger');
        this.loading = false;
      }
    },
  },
};

export default {
  data() {
    return {
      files: [],
      selected: this.$ctforge.getTheme(),
    };
  },
  computed: {
    userinfo() {
      return this.$ctforge.state.userinfo;
    },
    themes() {
      return this.$ctforge.listThemes();
    },
  },
  methods: {
    async changeTheme() {
      await this.$ctforge.setTheme(this.selected);
      window.location.reload(true);
    },
    openSetNickname() {
      const modal = this.$buefy.modal.open({
        parent: this,
        component: SetNicknameForm,
        hasModalCard: true,
        trapFocus: false,
      });
      modal.$on('close', async () => {
        await this.$ctforge.checkLogin();
      });
    },
  },
  async mounted() {
    document.title = 'User Profile';
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      this.files = await this.$ctforge.api.get('/user/files');
    } catch (e) {
      this.notify(e.message, 'is-danger');
    }
    loadingComponent.close();
  },
};
</script>

<style>
</style>
